<template>
	<div v-loading="loading" class="main-content">
		<div v-if="!loading" class="main-content-inner">
			<div class="container-fluid">
				<div class="row">
					<div class="col-lg-12 content-margin">
						<div class="content">
							<div class="content-header">
								<h2>
									Profile
								</h2>
							</div>
							<div class="content-body">
								<el-form @submit.prevent.native="handleSubmit('form')" :model="form" :rules="rules" ref="form">
									<div v-if="user.role === 1" class="row">
										<div class="col-lg-6 col-sm-12">
											<el-form-item label="Role" prop="role">
												<el-select v-model="form.role" disabled>
													<el-option v-for="(item, index) in roles" :key="index" :label="item.name" :value="item.id"></el-option>
												</el-select>
											</el-form-item>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-6 col-md-12">
											<el-form-item label="First name" prop="first_name">
												<el-input type="text" v-model="form.first_name" placeholder="Please enter first name"></el-input>
											</el-form-item>
										</div>
										<div class="col-lg-6 col-md-12">
											<el-form-item label="Last name" prop="last_name">
												<el-input type="text" v-model="form.last_name" placeholder="Please enter last name"></el-input>
											</el-form-item>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-6 col-md-12">
											<el-form-item label="Email">
												<el-input type="email" v-model="form.email" disabled></el-input>
											</el-form-item>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-6 col-md-12">
											<el-form-item label="Password (only if you want to change)" prop="password">
												<el-input type="password" v-model="form.password" placeholder="Please enter password"></el-input>
											</el-form-item>
										</div>
										<div class="col-lg-6 col-md-12">
											<el-form-item label="Confirm password" prop="password">
												<el-input type="password" v-model="form.password_confirmation" placeholder="Please confirm password"></el-input>
											</el-form-item>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-6 col-md-12">
											<el-form-item>
												<el-button native-type="submit" type="primary" plain>Save</el-button>
											</el-form-item>
										</div>
									</div>
								</el-form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { HTTP } from '@/services/api'
import { mapState } from 'vuex'

export default {
	name: 'Profile',
	metaInfo () {
		return {
			title: 'Profile',
		}
	},
	data () {
        return {
			loading: true,
			form: {},
			roles: [],
			rules: {
				first_name: [
					{ required: true, message: 'This field cannot be empty', trigger: 'blur' },
				],
				last_name: [
					{ required: true, message: 'This field cannot be empty', trigger: 'blur' },
				],
				password: [
					{ min: 8, message: 'Password must have at least 8 characters', trigger: 'blur' },
				],
				password_confirmation: [
					{ min: 8, message: 'Password must have at least 8 characters', trigger: 'blur' },
				]
			}
        }
    },
	computed: {
        ...mapState(['user'])
	},
	mounted () {
		this.form = JSON.parse(JSON.stringify(this.user))
		if (this.user.role === 1) {
			this.loadRoles()
		} else {
			this.loading = false
		}
	},
	methods: {
		loadRoles () {
			return HTTP({
				method: 'GET',
				url: '/roles/',
				crossdomain: true
			})
			.then(response => {
				this.roles = response.data
				this.loading = false
			})
			.catch(error => {
				this.loading = false
				this.$notify({
					title: 'Error',
					message: error.response.data.status ? error.response.data.status : 'An error occured, please try later',
					type: 'error',
					position: 'bottom-right',
					duration: 3500
				})
			})
		},
		handleSubmit (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading = true
					return HTTP({
						method: 'PUT',
						url: '/users/' + this.user.id,
						crossdomain: true,
						data: this.form
					})
					.then(() => {
						this.loading = false
						let newData = {
							id: this.form.id,
							first_name: this.form.first_name,
							last_name: this.form.last_name,
							email: this.user.email,
							role: this.user.role
						}
						this.$store.dispatch('setUser', newData)
						this.$notify({
							title: 'Success',
							message: 'Profile has been updated',
							type: 'success',
							position: 'bottom-right',
							duration: 2500
						})
					})
					.catch(error => {
						this.loading = false
						this.$notify({
							title: 'Error',
							message: error.response.data.message ? error.response.data.message : 'An error occured, please try later',
							type: 'error',
							position: 'bottom-right',
							duration: 3500
						})
					})
				} else {
					return false
				}
			})
		}
	}
}
</script>
